import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageUtilityLib {
  /**
   *  This method is set local storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  setLocalStorage<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *  This method is get data from local storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  getLocalStorage<T>(key: string, defaultValue = '{}'): T {
    const item = localStorage.getItem(key) || defaultValue;
    return JSON.parse(item) as T;
  }

  /**
   * This method is get data from local storage, if exist.
   *
   * @param key
   * @returns the value or null if not set
   */
  getLocalStorageNullable<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  /**
   *  This method is remove item from local storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  clearLocalStorage(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   *  This method is clear local storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  clearAllLocalStorage(): void {
    localStorage.clear();
  }

  /**
   *  This method is set session storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  setSessionStorage<T>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   *  This method is get data from session storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  getSessionStorage<T>(key: string): T {
    const item = sessionStorage.getItem(key) || '{}';
    return JSON.parse(item) as T;
  }

  /**
   *
   * @param key
   * @returns
   */
  getSessionStorageNullable<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  /**
   *  This method is remove item from session storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  clearSessionStorage(key: string): void {
    sessionStorage.removeItem(key);
  }

  /**
   *  This method is clear session storage
   *
   * @returns {string}
   *
   * @memberOf StorageUtilityLib
   */
  clearAllSessionStorage(): void {
    sessionStorage.clear();
  }
}
